$(document).ready(function (event) {
  $(document).on('submit', '.Card--product-form, .Product__form', function (event) {
    event.preventDefault();
    const thisForm = $(this);
    const thisFormSerialize = thisForm.serialize();
    thisForm.find('[data-add-to-cart]').addClass('loading'); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: thisFormSerialize,
      success: function (response) { addToCartSuccess(response, thisForm) },
      error: function (obj, status) { addToCartError(obj, status, thisForm) },
    });
  });
});

const addToCartSuccess = function (response, thisForm, quantity) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (response2) {
      thisForm.find('[data-add-to-cart]').removeClass('loading');
      var min_cart_value_for_giftcard = $('#gift-product-details #min_cart_value').val();
      var total_cart_value = response2.total_price/100;
      var gift_product_id = $('#gift-product-details #product_id').val();
      var gift_added = false;
      $.each(response2.items, function(k, v){
        if(gift_product_id == v['id']){
          gift_added = true;
        }
      });
      if(gift_product_id != '' && min_cart_value_for_giftcard != '' && min_cart_value_for_giftcard > 0 && parseInt(min_cart_value_for_giftcard) <= total_cart_value && gift_added == false){
         $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {"id": gift_product_id, "quantity": 1},
          success: function (response) {
            $.ajax({
              url: window.location.href,
              type: 'GET',
              success: function(result2) {
                $('.cart-table').html($(result2).find('.cart-table').html());
                $('.cart-subtotal').html($(result2).find('.cart-subtotal').html());
                $('.cart-count').text(response2.item_count+response.quantity);
              },
              error: function (error) {
              
              }
            });                             
          },
          error: function (obj, status) { console.log("error=", status); },
        });
      } else {
        $('.cart-count').text(response2.item_count);
      }
      
      $('html, body').animate({ scrollTop: 0 }, 500);
      $('.cart-notification').addClass('is-visible');
    
      setTimeout( function () {
        $('.cart-notification').removeClass('is-visible');
      }, 3000);
    },
    error: function (obj, status) {
      console.log(obj, status);

      thisForm.find('[data-add-to-cart]').removeClass('loading');
    }
  });
}

const addToCartError = function (obj, status, thisForm) {
  const responseErrorText = $.parseJSON(obj.responseText);
  
  thisForm.find('[data-add-to-cart]').removeClass('loading');

  if ($('.productForm-error').length == 0) {
    $(`<div class="productForm-error">${responseErrorText.description}</div>`).insertBefore(thisForm.find('[data-add-to-cart]'));
    setTimeout( function () {
      $('.productForm-error').remove();
    }, 3000);
  }
}